document.addEventListener('DOMContentLoaded', function () {
  const root = document.getElementById('help-center-root');
  const mainTitle = document.getElementById('help-center-main-title');
  const searchInput = document.getElementById('help-center-search-input');
  const stateContent = document.getElementById('help-center-state-content');
  const articlesUrl = window.helpCenterArticlesUrl;
  const fallbackArticlesUrl = window.helpCenterArticlesFallbackUrl;
  const embeddedArticles = window.helpCenterArticlesData;
  const topicIconUrls = window.helpCenterTopicIcons || {};

  if (!root || !mainTitle || !searchInput || !stateContent || !articlesUrl) {
    return;
  }

  const state = {
    view: 'home',
    activeCategory: null,
    query: '',
    articles: [],
    categories: []
  };

  if (Array.isArray(embeddedArticles) && embeddedArticles.length) {
    initializeFromData(embeddedArticles);
  } else {
    loadArticlesData()
      .then((data) => {
        initializeFromData(data);
      })
      .catch(() => {
        stateContent.innerHTML = '<p class="help-center-empty">We could not load help articles right now.</p>';
      });
  }

  function fetchArticlesFrom(url) {
    if (!url) {
      return Promise.reject(new Error('Missing help center article URL.'));
    }

    return fetch(url).then((response) => {
      if (!response.ok) {
        throw new Error('Unable to load help center articles.');
      }

      return response.json();
    });
  }

  function loadArticlesData() {
    return fetchArticlesFrom(articlesUrl).catch(() => {
      if (fallbackArticlesUrl && fallbackArticlesUrl !== articlesUrl) {
        return fetchArticlesFrom(fallbackArticlesUrl);
      }

      throw new Error('Unable to load help center articles.');
    });
  }

  function initializeFromData(data) {
    state.articles = normalizeArticles(data);
    state.categories = getOrderedCategories(state.articles);
    hydrateStateFromUrl();
    bindEvents();
    render();
  }

  function normalizeArticles(data) {
    if (!Array.isArray(data)) {
      return [];
    }

    return data.map((article, index) => {
      const normalizedLinks = normalizeLinks(article.related_links);
      const sortOrder = Number(normalizeText(article.order));
      const featuredOrder = Number(normalizeText(article.featured_faq_order));
      const normalizedTitle = normalizeText(article.title);
      const normalizedQuestion = normalizeText(article.question);

      return {
        id: normalizeText(article.id) || String(index + 1),
        title: normalizedTitle || normalizedQuestion,
        category: normalizeText(article.category),
        question: normalizedQuestion || normalizedTitle,
        answer: normalizeText(article.answer),
        order: Number.isFinite(sortOrder) ? sortOrder : 999,
        related_links: normalizedLinks,
        featured_faq: normalizeBoolean(article.featured_faq),
        featured_faq_order: Number.isFinite(featuredOrder) ? featuredOrder : 999,
        featured_faq_label: normalizeText(article.featured_faq_label)
      };
    });
  }

  function normalizeText(value) {
    if (value == null) {
      return '';
    }

    if (typeof value === 'string' || typeof value === 'number') {
      return String(value).trim();
    }

    if (typeof value === 'boolean') {
      return value ? 'true' : 'false';
    }

    if (Array.isArray(value)) {
      const first = value.map((item) => normalizeText(item)).find(Boolean);
      return first || '';
    }

    if (typeof value === 'object') {
      const keys = ['value', 'label', 'name', 'title', 'text', 'handle', 'key'];

      for (const key of keys) {
        if (Object.prototype.hasOwnProperty.call(value, key)) {
          const normalized = normalizeText(value[key]);
          if (normalized) {
            return normalized;
          }
        }
      }

      // Rich text and other structured payloads may nest text deeply.
      const deepText = extractDeepText(value);
      if (deepText) {
        return deepText;
      }
    }

    return '';
  }

  function extractDeepText(node) {
    if (node == null) {
      return '';
    }

    if (typeof node === 'string' || typeof node === 'number') {
      return String(node).trim();
    }

    if (typeof node === 'boolean') {
      return node ? 'true' : 'false';
    }

    if (Array.isArray(node)) {
      const merged = node.map((item) => extractDeepText(item)).filter(Boolean).join(' ').trim();
      return merged;
    }

    if (typeof node === 'object') {
      const ignoreKeys = new Set(['id', 'type', 'url', 'href']);
      const merged = Object.entries(node)
        .filter(([key]) => !ignoreKeys.has(key))
        .map(([, value]) => extractDeepText(value))
        .filter(Boolean)
        .join(' ')
        .replace(/\s+/g, ' ')
        .trim();

      return merged;
    }

    return '';
  }

  function normalizeBoolean(value) {
    if (value === true || value === false) {
      return value;
    }

    const normalized = normalizeText(value).toLowerCase();
    return normalized === 'true' || normalized === '1' || normalized === 'yes';
  }

  function normalizeLinks(value) {
    if (Array.isArray(value)) {
      return value
        .map((item) => {
          if (typeof item === 'object' && item) {
            return normalizeText(item.url || item.value || item.href);
          }
          return normalizeText(item);
        })
        .filter(Boolean);
    }

    const normalizedValue = normalizeText(value);

    if (normalizedValue) {
      return normalizedValue
        .split(/\n|,/)
        .map((item) => item.trim())
        .filter(Boolean);
    }

    return [];
  }

  function bindEvents() {
    searchInput.addEventListener('input', function (event) {
      state.query = event.target.value.trim();

      if (state.query) {
        state.view = 'search';
      } else if (state.activeCategory) {
        state.view = 'topic';
      } else {
        state.view = 'home';
      }

      updateUrlState(false);
      render();
    });

    stateContent.addEventListener('click', function (event) {
      const topicCard = event.target.closest('[data-topic-card]');
      const backToHome = event.target.closest('[data-back-home]');
      const faqLink = event.target.closest('[data-faq-topic]');
      const topicJump = event.target.closest('[data-topic-jump]');
      const accordionButton = event.target.closest('.help-center-accordion-question');

      if (topicCard) {
        openTopic(topicCard.getAttribute('data-topic-card'), true);
        return;
      }

      if (faqLink) {
        openTopic(faqLink.getAttribute('data-faq-topic'), true);
        return;
      }

      if (topicJump) {
        openTopic(topicJump.getAttribute('data-topic-jump'), true);
        return;
      }

      if (backToHome) {
        event.preventDefault();
        state.activeCategory = null;
        state.query = '';
        searchInput.value = '';
        state.view = 'home';
        updateUrlState(true);
        render();
        return;
      }

      if (accordionButton) {
        toggleAccordionItem(accordionButton);
      }
    });

    window.addEventListener('popstate', function () {
      hydrateStateFromUrl();
      render();
    });
  }

  function render() {
    root.setAttribute('data-view', state.view);

    if (state.view === 'topic' && state.activeCategory) {
      stateContent.innerHTML = renderTopicView();
      return;
    }

    if (state.view === 'search' && state.query) {
      stateContent.innerHTML = renderSearchView();
      return;
    }

    stateContent.innerHTML = renderHomeView();
  }

  function renderHomeView() {
    const faqPreviewItems = getFaqPreviewItems(state.articles);

    return `
      <section class="help-center-section" aria-label="Popular Topics">
        <h2 class="help-center-section-title">Popular Topics</h2>
        <div class="help-center-topic-grid">
          ${state.categories
            .map(
              (category) => `
                <button type="button" class="help-center-topic-card" data-topic-card="${escapeAttribute(category)}">
                  <span class="help-center-topic-visual" aria-hidden="true">
                    <span class="help-center-topic-icon-tile">
                      ${renderTopicIcon(category)}
                    </span>
                  </span>
                  <span class="help-center-topic-label">${escapeHtml(category)}</span>
                </button>
              `
            )
            .join('')}
        </div>
      </section>

      <section class="help-center-section help-center-faq-preview" aria-label="Frequently Asked Questions">
        <h2 class="help-center-faq-title">Frequently Asked Questions</h2>
        <div class="help-center-faq-links">
          ${faqPreviewItems
            .map(
              (item) => `
                <button type="button" class="help-center-faq-link" data-faq-topic="${escapeAttribute(item.category)}">
                  ${escapeHtml(item.label)}
                </button>
              `
            )
            .join('')}
        </div>
      </section>
    `;
  }

  function getFaqPreviewItems(articles) {
    const configured = articles
      .filter((article) => article.featured_faq === true)
      .sort((a, b) => (a.featured_faq_order || 999) - (b.featured_faq_order || 999))
      .map((article) => ({
        category: article.category,
        label: article.featured_faq_label || getDisplayQuestion(article)
      }));

    if (configured.length) {
      return configured.slice(0, 3);
    }

    return articles
      .slice()
      .sort((a, b) => a.order - b.order)
      .slice(0, 3)
      .map((article) => ({
        category: article.category,
        label: getDisplayQuestion(article)
      }));
  }

  function getDisplayQuestion(article) {
    return article.question || article.title || 'Untitled question';
  }

  function renderTopicIcon(category) {
    const iconUrl = topicIconUrls[category];

    if (!iconUrl) {
      return '<span class="help-center-topic-icon-placeholder"></span>';
    }

    return `<img class="help-center-topic-icon-image" src="${escapeAttribute(iconUrl)}" alt="" loading="lazy" decoding="async">`;
  }

  function renderTopicView() {
    const topicArticles = getArticlesForTopic(state.activeCategory).filter((article) => matchesQuery(article, state.query));

    return `
      <div class="help-center-topic-head">
        <button type="button" class="help-center-back-link" data-back-home>&larr; All Help Topics</button>
        <h2 class="help-center-topic-title">${escapeHtml(state.activeCategory)}</h2>
      </div>
      <section class="help-center-topic-content" aria-label="${escapeAttribute(state.activeCategory)} questions and answers">
        ${
          topicArticles.length
            ? topicArticles
                .map(
                  (article) => `
                    <article class="help-center-topic-item">
                      <h3 class="help-center-topic-question">${escapeHtml(getDisplayQuestion(article))}</h3>
                      <div class="help-center-topic-answer">${formatAnswer(article.answer, article.related_links)}</div>
                    </article>
                  `
                )
                .join('')
            : '<p class="help-center-empty">No matches in this topic. Try another search term.</p>'
        }
      </section>
    `;
  }

  function renderSearchView() {
    const allMatches = state.articles.filter((article) => matchesQuery(article, state.query));
    const heading = state.activeCategory || 'Search Results';

    if (!allMatches.length) {
      return '<p class="help-center-empty">No matching help articles found. Try a different search term.</p>';
    }

    const primaryMatches = state.activeCategory
      ? allMatches.filter((article) => article.category === state.activeCategory)
      : [];
    const secondaryMatches = state.activeCategory
      ? allMatches.filter((article) => article.category !== state.activeCategory)
      : allMatches;

    let output = `
      <section class="help-center-search-results" aria-label="Search results">
        <h2 class="help-center-topic-title">${escapeHtml(heading)}</h2>
        <p class="help-center-results-count">${allMatches.length} result${allMatches.length === 1 ? '' : 's'} for "${escapeHtml(state.query)}"</p>
    `;

    if (state.activeCategory) {
      output += `
        <h2 class="help-center-results-heading">Results in ${escapeHtml(state.activeCategory)}</h2>
        <div class="help-center-accordion" data-accordion-root>
          ${
            primaryMatches.length
              ? renderAccordionItems(primaryMatches, `primary-${slugify(state.activeCategory)}`)
              : '<p class="help-center-empty">No matches in this topic.</p>'
          }
        </div>
      `;
    }

    output += `
      <h2 class="help-center-results-heading">${state.activeCategory ? 'Also found in other topics' : 'Results across topics'}</h2>
      ${renderSearchGroups(secondaryMatches)}
      </section>
    `;

    return output;
  }

  function renderSearchGroups(articles) {
    const grouped = groupByCategory(articles);
    const categories = Object.keys(grouped);

    if (!categories.length) {
      return '<p class="help-center-empty">No additional matches found.</p>';
    }

    return categories
      .map(
        (category) => `
          <section class="help-center-search-group">
            <h3>
              <button type="button" class="help-center-topic-jump" data-topic-jump="${escapeAttribute(category)}">${escapeHtml(category)}</button>
            </h3>
            <div class="help-center-accordion" data-accordion-root>
              ${renderAccordionItems(grouped[category], `group-${slugify(category)}`)}
            </div>
          </section>
        `
      )
      .join('');
  }

  function renderAccordionItems(items, idSeed) {
    return items
      .slice()
      .sort((a, b) => a.order - b.order)
      .map((article, index) => {
        const questionId = `help-center-${idSeed}-q-${index + 1}`;
        const answerId = `help-center-${idSeed}-a-${index + 1}`;

        return `
          <article class="help-center-accordion-item">
            <button
              type="button"
              class="help-center-accordion-question"
              id="${questionId}"
              aria-expanded="false"
              aria-controls="${answerId}"
            >
              <span>${escapeHtml(getDisplayQuestion(article))}</span>
            </button>
            <div class="help-center-accordion-answer" id="${answerId}" role="region" aria-labelledby="${questionId}" tabindex="-1" hidden>
              <div class="help-center-accordion-answer-inner">${formatAnswer(article.answer, article.related_links)}</div>
            </div>
          </article>
        `;
      })
      .join('');
  }

  function toggleAccordionItem(button) {
    const rootEl = button.closest('[data-accordion-root]');

    if (!rootEl) {
      return;
    }

    const expanded = button.getAttribute('aria-expanded') === 'true';

    rootEl.querySelectorAll('.help-center-accordion-question').forEach((candidate) => {
      const answer = candidate.nextElementSibling;
      const isCurrent = candidate === button;

      if (!isCurrent) {
        candidate.setAttribute('aria-expanded', 'false');
        if (answer) {
          answer.hidden = true;
        }
      }
    });

    button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    const targetAnswer = button.nextElementSibling;

    if (targetAnswer) {
      targetAnswer.hidden = expanded;
      if (!expanded) {
        targetAnswer.focus();
      }
    }
  }

  function openTopic(category, pushHistory) {
    if (!category) {
      return;
    }

    state.activeCategory = category;
    state.query = '';
    searchInput.value = '';
    state.view = 'topic';
    updateUrlState(pushHistory);
    render();
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function hydrateStateFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const topicSlug = params.get('topic');
    const query = params.get('q') || '';

    state.query = query;
    searchInput.value = query;

    if (topicSlug) {
      const found = state.categories.find((category) => slugify(category) === topicSlug);
      state.activeCategory = found || null;
    } else {
      state.activeCategory = null;
    }

    if (state.query) {
      state.view = 'search';
    } else if (state.activeCategory) {
      state.view = 'topic';
    } else {
      state.view = 'home';
    }
  }

  function updateUrlState(pushHistory) {
    const url = new URL(window.location.href);

    if (state.activeCategory) {
      url.searchParams.set('topic', slugify(state.activeCategory));
    } else {
      url.searchParams.delete('topic');
    }

    if (state.query) {
      url.searchParams.set('q', state.query);
    } else {
      url.searchParams.delete('q');
    }

    if (pushHistory) {
      window.history.pushState({}, '', url.toString());
    } else {
      window.history.replaceState({}, '', url.toString());
    }
  }

  function getArticlesForTopic(category) {
    return state.articles
      .filter((article) => article.category === category)
      .sort((a, b) => a.order - b.order);
  }

  function getOrderedCategories(articles) {
    const preferred = [
      'Shipping & Delivery',
      'Returns',
      'Orders & Payments',
      'Wholesale & Brand Partners',
      'Product Care & Fit Guide',
      'Gift Cards'
    ];

    const found = Array.from(new Set(articles.map((article) => article.category).filter(Boolean)));
    const ordered = preferred.filter((item) => found.includes(item));
    const remainder = found.filter((item) => !preferred.includes(item)).sort();

    return ordered.concat(remainder);
  }

  function groupByCategory(articles) {
    return articles.reduce((acc, article) => {
      if (!acc[article.category]) {
        acc[article.category] = [];
      }

      acc[article.category].push(article);
      return acc;
    }, {});
  }

  function matchesQuery(article, query) {
    if (!query) {
      return true;
    }

    const haystack = [article.title, article.question, article.answer, article.category]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();

    return haystack.includes(query.toLowerCase());
  }

  function isAllowedLinkUrl(value) {
    if (!value) {
      return false;
    }

    const trimmed = String(value).trim();

    if (/^\/(?!\/)/.test(trimmed)) {
      return true;
    }

    return /^(https?:|mailto:|tel:)/i.test(trimmed);
  }

  function getLinkAttributes(url) {
    const trimmed = String(url || '').trim();

    if (/^\/(?!\/)/.test(trimmed)) {
      return '';
    }

    return /^https?:/i.test(trimmed) ? ' target="_blank" rel="noreferrer"' : '';
  }

  function formatAnswer(answer, relatedLinks) {
    const rawAnswer = String(answer || '');
    const placeholders = [];
    const consumedLinkIndexes = new Set();
    let linkTokenIndex = 0;

    const answerWithPlaceholders = rawAnswer.replace(/\[link\]([\s\S]*?)\[\/link\]/gi, (_, labelText) => {
      const placeholder = `HC_LINK_TOKEN_${placeholders.length}`;
      const label = String(labelText || '').trim();
      const hasMatchingLink = Array.isArray(relatedLinks) && linkTokenIndex < relatedLinks.length;
      const rawUrl = hasMatchingLink ? String(relatedLinks[linkTokenIndex] || '').trim() : '';

      if (hasMatchingLink) {
        consumedLinkIndexes.add(linkTokenIndex);
      }

      if (rawUrl && isAllowedLinkUrl(rawUrl)) {
        placeholders.push(
          `<a href="${escapeAttribute(rawUrl)}"${getLinkAttributes(rawUrl)}>${escapeHtml(
            label || rawUrl.replace(/^mailto:/i, '')
          )}</a>`
        );
      } else {
        placeholders.push(escapeHtml(label));
      }

      linkTokenIndex += 1;
      return placeholder;
    });

    let formattedAnswer = escapeHtml(answerWithPlaceholders)
      .replace(/\n\n+/g, '</p><p>')
      .replace(/\n/g, '<br>');

    placeholders.forEach((replacement, index) => {
      const token = `HC_LINK_TOKEN_${index}`;
      formattedAnswer = formattedAnswer.replace(token, replacement);
    });

    let output = `<p>${formattedAnswer}</p>`;

    if (Array.isArray(relatedLinks) && relatedLinks.length) {
      const remainingLinks = relatedLinks.filter((_, index) => !consumedLinkIndexes.has(index));

      if (remainingLinks.length) {
        output += `<ul class="help-center-related-links">${remainingLinks
          .map(
            (rawLink) => {
              const link = String(rawLink || '').trim();
              const label = escapeHtml(link.replace(/^mailto:/i, ''));

              if (!isAllowedLinkUrl(link)) {
                return `<li>${label}</li>`;
              }

              return `<li><a href="${escapeAttribute(link)}"${getLinkAttributes(link)}>${label}</a></li>`;
            }
          )
          .join('')}</ul>`;
      }
    }

    return output;
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function escapeAttribute(value) {
    return String(value || '').replace(/"/g, '&quot;');
  }

  function slugify(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }
});
